"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AltiumFileType = void 0;
var AltiumFileType;
(function (AltiumFileType) {
    AltiumFileType["PcbDoc"] = ".PcbDoc";
    AltiumFileType["SchDoc"] = ".SchDoc";
    AltiumFileType["Sch"] = ".Sch";
    AltiumFileType["Project"] = ".PrjPCB";
    AltiumFileType["ProjectStructure"] = ".PrjPcbStructure";
    AltiumFileType["ProjectVariants"] = ".PrjPcbVariants";
    AltiumFileType["OutJob"] = ".OutJob";
    AltiumFileType["PcbDrawing"] = ".PCBDwf";
    AltiumFileType["Harness"] = ".Harness";
    AltiumFileType["BomDoc"] = ".BomDoc";
    AltiumFileType["Stackup"] = ".stackup";
    AltiumFileType["Netlist"] = ".Net";
    AltiumFileType["Annotation"] = ".Annotation";
})(AltiumFileType || (exports.AltiumFileType = AltiumFileType = {}));
//# sourceMappingURL=altiumFileTypes.js.map